<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'paymentApplyAdd',
    components: {
      baseEdit,
    },
  };
</script>
